"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LANGUAGES_OPTIONS = exports.FORM_FIELDS = exports.EDIT_FORM_UI = exports.DEFAULT_TEMPLATE = void 0;
var _localization = _interopRequireWildcard(require("../../../../../../localization"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FORM_FIELDS = exports.FORM_FIELDS = {
  TITLE: 'title',
  COMMENT: 'comment',
  TEMPLATE: 'template',
  DISCOUNT: 'discount',
  MARGIN: 'margin',
  SHOW_PRICE_WITH_MARGIN: 'showPriceWithMargin',
  LOCALE: 'locale',
  ROUND: 'round',
  OFFERS_REVIEWS_LINK: 'offersReviewsLink',
  RATING: 'rating'
};
var LANGUAGES_OPTIONS = exports.LANGUAGES_OPTIONS = [{
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:UK_UA');
  },
  value: _localization.UA_LOCALE
}, {
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:RU');
  },
  value: _localization.RU_LOCALE
}, {
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:EN');
  },
  value: _localization.EN_LOCALE
}, {
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:KZ');
  },
  value: _localization.KK_LOCALE
}, {
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:RO_RO');
  },
  value: _localization.RO_LOCALE
}, {
  get content() {
    return _localization.default.t('BASKET_EDIT_FORM:LANGUAGES_OPTIONS:PL');
  },
  value: _localization.PL_LOCALE
}];
var DEFAULT_TEMPLATE = exports.DEFAULT_TEMPLATE = 'compact';
var EDIT_FORM_UI = exports.EDIT_FORM_UI = 'EDIT_FORM_UI';